import store from '../../store';

const REDIRECT_URL = process.env.VUE_APP_IZZI_LOGIN || 'http://35.171.76.85:14100/fact-auth-service/FactAuth/login?response_type=code&client_id=8b4bf6893a2a4c1da0203ef466f040aa&redirect_uri=https://auth.machete-plus.kadavra.xyz/oauth/callback&scope=UserProfile.me&state=getauthz';
const REDIRECT_URL_PRO = process.env.VUE_APP_IZZI_LOGIN_PRO || 'http://35.171.76.85:14100/fact-auth-pro-service/FactAuth/login?response_type=code&client_id=222c1212712442e2ba86ec17a11af530&redirect_uri=https://auth-machete.devctinube.com/oauth/pro/callback&scope=UserProfile.me&state=getauthz';

async function notSignInRoute(to, from, next) {
  if (store.state.auth.signed) next({ name: 'Home' });
  else {
    try {
      await store.dispatch('auth/initAuthentication');
      next({ name: 'Home' });
    } catch (error) {
      next();
    }
  }
}

async function initAuthentication(to, from, next, redirect) {
  if (!to.query.accessToken) {
    window.location = redirect;
    return null;
  }

  if (store.state.auth.signed) {
    return next({ name: 'Home' });
  }

  if (to.query.accessToken) {
    sessionStorage.setItem('access_token', to.query.accessToken);
  }

  const logoutPath = (to.query.referer && to.query.referer === 'pro') ? 'SignInPro' : 'Landing';
  sessionStorage.setItem('logoutRedirect', logoutPath);

  try {
    await store.dispatch('auth/initAuthentication');
    return next({ name: 'Home' });
  } catch (error) {
    return next();
  }
}

export default [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "auth" */ '../../views/Auth/index.vue'),
    redirect: { name: 'SignIn' },
    children: [
      {
        path: 'sign-up',
        name: 'SignUp',
        component: () => import(/* webpackChunkName: "sign-up" */ '../../views/Auth/SignUp.vue'),
        beforeEnter: notSignInRoute,
      },
      {
        path: 'sign-in',
        name: 'SignIn',
        component: () => import(/* webpackChunkName: "sign-in" */ '../../views/Auth/SignIn.vue'),
        async beforeEnter(to, from, next) {
          return initAuthentication(
            to,
            from,
            next,
            REDIRECT_URL,
            'Landing',
          );
        },
      },
      {
        path: 'sign-out',
        name: 'SignOut',
        beforeEnter(to, from, next) {
          const logoutPath = sessionStorage.getItem('logoutRedirect');

          store.dispatch('auth/signOut');
          store.commit('auth/setInitialState');
          store.commit('ui/clearState');
          next({ name: logoutPath });
        },
      },
      {
        path: 'verification-pending',
        name: 'VerificationPending',
        component: () => import(/* webpackChunkName: "verification-pending" */ '../../views/Auth/VerificationPending.vue'),
        meta: {
          auth: true,
        },
        beforeEnter(to, from, next) {
          if (store.state.auth.emailVerified) next({ name: 'Home' });
          else next();
        },
      },
      {
        path: 'verify-email',
        name: 'VerifyEmail',
        component: () => import(/* webpackChunkName: "verify-email" */ '../../views/Auth/VerifyEmail.vue'),
        beforeEnter: notSignInRoute,
      },
      {
        path: 'forgotten-password',
        name: 'ForgottenPassword',
        component: () => import(/* webpackChunkName: "forgotten-password" */ '../../views/Auth/ForgottenPassword.vue'),
        beforeEnter: notSignInRoute,
      },
      {
        path: 'password-recovery',
        name: 'PasswordRecovery',
        alias: 'set-password',
        component: () => import(/* webpackChunkName: "password-recovery" */ '../../views/Auth/PasswordRecovery.vue'),
        beforeEnter: notSignInRoute,
      },
      {
        path: 'sign-up/with-company',
        name: 'SignUpWithCompany',
        redirect: '/auth/sign-up/with-rfc',
      },
      {
        path: 'sign-up/with-rfc',
        name: 'SignUpWithRfc',
        component: () => import(/* webpackChunkName: "sign-up-with-rfc" */ '../../views/Auth/SignUpWithRfc.vue'),
        beforeEnter: notSignInRoute,
      },
    ],
  },
  {
    path: '/pro',
    name: 'SignInPro',
    component: () => import(/* webpackChunkName: "sign-in" */ '../../views/Auth/SignIn.vue'),
    async beforeEnter(to, from, next) {
      if (sessionStorage.getItem('access_token')) {
        return next({ name: 'Home' });
      }

      return initAuthentication(
        to,
        from,
        next,
        REDIRECT_URL_PRO,
      );
    },
  },
];
